export default __webpack_public_path__ + "static/agent1-6ca178dc283eda57b94ed64f573530ea.png";